module.exports = __webpack_public_path__ + "static/verbosideral-62fdd5cf079d19550114c4e9a1e56ae1.mp4";